import { mapKeySourceFor, type MapKeySource } from '@dorixona/api/maps'
import { env } from '../config/env'
import { useApi } from './context'

/**
 * Ключ Яндекс Карт: флаг `VITE_FEATURE_MAPS_KEYS` включён — только из пула на
 * сервере (пул пуст — карта показывает ошибку), выключен — ключ сборки.
 * Объект один на приложение.
 */
export function useMapKeySource(): MapKeySource {
  return mapKeySourceFor(useApi(), { pool: env.features.mapsKeys, buildKey: env.yandexMapsKey })
}

/**
 * Ключ геокодера: свой ключ из сборки (`VITE_YANDEX_GEOCODER_KEY`) главнее,
 * иначе — тот же, что у карт: ключ из кабинета Яндекса открыт для обоих API.
 */
export function useGeocoderKeySource(): MapKeySource {
  const api = useApi()
  const maps = useMapKeySource()
  const own = env.yandexGeocoderKey === env.yandexMapsKey ? '' : env.yandexGeocoderKey
  return own ? mapKeySourceFor(api, { pool: false, buildKey: own }) : maps
}
